<div class="row">
    <div class="col-lg-12">
        <div class="clearfix">            
            <ul class="nav nav-tabs custom top">
                <li class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#ncr"><strong>Quality Assurance Report</strong></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#car"><strong>Corrective Action Report</strong></a>
                </li>
            </ul>
        </div>

        <div class="tab-content top">
                
            <!-------------- TAB A -------------->
            <div class="tab-pane active" id="ncr">
                            
                 <!-- Feature Menu Icons-->
                <div class="row">
                    <div class="col-md-12">
                        
                        <button type="button" class="btn btn-secondary btn-sm mb-1 mr-1" aria-expanded="false" placement="bottom" ngbTooltip="Add New QAR" (click)="openNCRModal(null)">
                            <span class="sr-only">Add</span>
                            <i class="fa fa-lg fa-plus"></i>
                            <span *ngIf="s_theme.menu_type == 'default'">&nbsp;Add</span>
                        </button>

                        <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print1()" placement="bottom" [disabled]="ncrCount < 1" ngbTooltip="Print List">
                            <i class="fa fa-lg fa-print"></i>
                            <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Print</span>
                        </button>
                        
                        <div class="btn-group mr-1">
                            <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="ncrCount < 1">
                                <i class="fa fa-lg fa-download"></i><span *ngIf="s_theme.menu_type == 'default'">&nbsp; Export</span>
                            </button>

                            <div class="dropdown-menu fs-12">
                                <a (click)="NCR_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                                <a (click)="NCR_exportToEXCEL()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a>
                                <a (click)="NCR_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                             </div>
                         </div>
                        
                        <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1" (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                            <i class="fa fa-lg fa-filter"></i>
                            <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Filter</span>
                        </button>
                                        
                        <div class="btn-group mb-1">
                            <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="sr-only">Toggle Dropdown</span>
                                <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="s_theme.menu_type == 'default'">&nbsp; Columns</span>
                            </button>

                             <div class="dropdown-menu fs-12" style="width: 150px;">
                                <div class="col-md-12 mb-3 fs-12">
                                    <input type="checkbox" [(ngModel)]="showBreachCategory"> Breach Category<br />
                                    <input type="checkbox" [(ngModel)]="showCode"> Breach Code<br />
                                    <input type="checkbox" [(ngModel)]="showProblemDetails"> Breach Details<br />
                                    <input type="checkbox" [(ngModel)]="showClassification"> Classification<br />
                                    <input type="checkbox" [(ngModel)]="showDriver"> Driver<br />
                                    <input type="checkbox" [(ngModel)]="showStatus"> Status<br />
                                </div>
                            </div>
                        </div>

                        <!-- <button type="button" [ngClass]="(showSidebar)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 ml-1" (click)="toggleSideBar()" placement="bottom" ngbTooltip="Toggle Sidebar">
                            <i class="fa fa-lg fa-toggle-right"></i>
                            <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Sidebar</span>
                            </button> -->
                        
                        </div>
                    </div>
  


                     <!-- <div class="col-md-12">
                         <button  type="button" class="btn btn-sm btn-success btn-sm mb-1" (click)="resetFilters()">
                                 <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-filter"></i></span>
                                 <span> Reset Filters</span>
                         </button> &nbsp; -->
                                    

                <div class="row">
                <!-- NCR TABLE -->
                    <div  class="col-md-12" align="left">
                        <span  class="card-body">
                            <a (click)="onClickStatus('Cancelled');">
                            <span class="badge badge-pill badge-danger pull-right">
                            <span [hidden]="filterStatus != 'Cancelled'">
                            <i class="fa fa-check"></i>&nbsp;</span>Cancelled</span></a>
    
                            <a (click)="onClickStatus('Terminated');">
                            <span class="badge badge-pill badge-warning pull-right">
                            <span [hidden]="filterStatus != 'Terminated'">
                            <i class="fa fa-check"></i>&nbsp;</span>Terminated</span></a>

                            <a (click)="onClickStatus('Resolved');">
                            <span class="badge badge-pill badge-completed pull-right">
                            <span [hidden]="filterStatus != 'Resolved'">
                            <i class="fa fa-check"></i>&nbsp;</span>Resolved</span></a>

                            <a (click)="onClickStatus('Processing');">
                            <span class="badge badge-pill badge-processing pull-right">
                            <span [hidden]="filterStatus != 'Processing'">
                            <i class="fa fa-check"></i>&nbsp;</span>Processing</span></a>

                            <a (click)="onClickStatus('Pending');">
                            <span class="badge badge-pill badge-pending pull-right">
                            <span [hidden]="filterStatus != 'Pending'">
                            <i class="fa fa-check"></i>&nbsp;</span>Pending</span></a>
                        </span><br />

                        <ngx-loading [show]="loadingIndicator"></ngx-loading>
                        <ngx-datatable *ngIf = "ncr_rows && !loadingIndicator"
                            [loadingIndicator]="loadingIndicator"
                            class="material"
                            [rows]="ncr_rows"
                            [columnMode]="'force'"
                            [footerHeight]="40"
                            [columns]="ncr_columns"
                            [rowHeight]="'auto'"
                            [limit]="10"
                            [selected]="selected"
                            [selectionType]="'single'"
                            [headerHeight]="showFilters?50:30">

                                <ngx-datatable-column prop="id" name="Operations" headerClass="header"  [width]="70" [cellClass]="getCellClass">
                                    <ng-template let-value="value" let-row="row"  ngx-datatable-cell-template>
                                        <div align="left" style="padding-right:20px">
                                            <a class="hover difot" title="Details" (click)="openNCRDetails(row)"><i class="fa fa-lg fa-book"></i></a>&nbsp;
                                            <a class="hover difot"  title="Edit Quality Assurance Report" (click)="openNCRModal(row)"><i class="fa fa-lg fa-edit mr-1"></i></a>
                                            <a class="cursorhover" title="Delete Quality Assurance Report" *ngIf="row.status_id == 1" (click)="openModalDelete(row)"><i class="fa fa-lg fa-trash mr-2"></i></a>
                                            <a class="hover difot" *ngIf="row.status_id == 1" title="Create Quality Assurance Report" (click)="openCARModal(row,false)"><i class="fa fa-lg fa-plus-square-o"></i></a>&nbsp;
                                        </div>
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Breach Category" prop="category_name"  headerClass="header" [width]="120" *ngIf="showBreachCategory" [cellClass]="getCellClass">
                                    <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                                        <span>{{column.name}}</span>
                                        <span *ngIf="showFilters">
                                        <input type="text" [(ngModel)]="filterBreachCategory" style="height:17px" 
                                        class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                        (keyup)="updateFilter()" />
                                        </span>
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Breach Code" prop="codename"  headerClass="header" [width]="120" *ngIf="showCode" [cellClass]="getCellClass">
                                    <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                                        <span>{{column.name}}</span>
                                        <span *ngIf="showFilters">
                                            <input type="text" [(ngModel)]="filterBreachCode" style="height:17px" 
                                            class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                            (keyup)="updateFilter()" />
                                        </span>
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Classification" prop="classification_name"  headerClass="header" [width]="120" *ngIf="showClassification" [cellClass]="getCellClass">
                                    <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                                        <span>{{column.name}}</span>
                                        <span *ngIf="showFilters">
                                            <input type="text" [(ngModel)]="filterBreachClass" style="height:17px" 
                                            class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                            (keyup)="updateFilter()" />
                                        </span>
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Driver" prop="driver_name"  headerClass="header" [width]="120" *ngIf="showDriver" [cellClass]="getCellClass">
                                    <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                                        <span>{{column.name}}</span>
                                        <span *ngIf="showFilters">
                                            <input type="text" [(ngModel)]="filterNcrDriver" style="height:17px" 
                                            class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                            (keyup)="updateFilter()" />
                                        </span>
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Status" prop="status_name"  headerClass="header" [width]="120" *ngIf="showStatus" [cellClass]="getCellClass"></ngx-datatable-column>

                                <ngx-datatable-column name="Breach Details" prop="problem_details"  headerClass="header" [width]="120" *ngIf="showProblemDetails" [cellClass]="getCellClass" ></ngx-datatable-column>

                                <ngx-datatable-column name="File" prop="file"  headerClass="header" [width]="120" *ngIf="showFile" [cellClass]="getCellClass" >
                                    <ng-template let-value="value" ngx-datatable-cell-template>
                                        <a class="incident_hover" href="{{fileStoragePath}}/ncr/{{value}}" target="_new">{{value}}</a>
                                    </ng-template>
                                </ngx-datatable-column>
                                   
                            </ngx-datatable>
                        </div><!-- END OF NCR TABLE -->

                        <!-- START OF NCR DETAILS -->
                            <ng-template #modalNCRDetails let-close="close">
                                <div widget class="card border-0 box-shadow selected-column">
                                    <div class="card-header transparent border-0 text-muted">
                                        <h5 class="mb-0" style="text-align: center;">Quality Assurance Report Details</h5>     
                                    </div>
                                    <div class="card-body pt-0 widget-body">
                                            <div *ngFor='let sel of selected, let i = index'>
                                                <div class="col-md-12 details">
                                                    <div class="row">

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <strong>Breach Category </strong>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            {{ sel.category_name }}
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <strong>Driver </strong>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                                {{ sel.driver_name}}
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <strong>Customer</strong>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <span *ngIf="sel.customer_id == null">No data recorded!</span>

                                                            <span *ngIf="sel.customer_id != null">
                                                                    <span *ngFor="let cust of customer">
                                                                            <span *ngIf="cust.id == sel.customer_id">{{ cust.company_name}}</span>
                                                                    </span>
                                                            </span>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <strong>Breach Code</strong>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            {{sel.codename}}
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <strong>Status:</strong>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <span class="badge badge-pill" [ngClass]="{
                                                                'badge-secondary': sel?.status_id  == 1,
                                                                'badge-primary': sel?.status_id == 2,
                                                                'badge-success': sel?.status_id == 3,
                                                                'badge-warning': sel?.status_id  == 4,
                                                                'badge-danger':  sel?.status_id == 5
                        
                                                                }">{{sel?.status_name}}</span>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <strong>Fleet</strong>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <span *ngIf="sel.fleet == ''">No data recorded!</span>
                                                            <span *ngIf="sel.fleet != null">{{ sel.fleet}}</span>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <strong>Manifest Number</strong>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <span *ngIf="sel.run_control_no == null">No data recorded!</span>
                                                            <span *ngIf="sel.run_control_no != null"> <a [routerLink]="['/dispatch/manifestdetails/', sel.run_id]" target="_blank"  *ngIf="(isEnabled('Local Manifest') || isEnabled('Linehaul Manifest')); else disabledLinkManifestDetails" > {{ sel.run_control_no}}</a></span>
                                                                <ng-template #disabledLinkManifestDetails>
                                                                    {{ sel.run_control_no}}
                                                                  </ng-template>
                                                            
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <strong>Breach Classification</strong>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            {{ sel.classification_name}}
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <strong>Created by</strong>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <span *ngIf="sel.created_by == null">No data recorded!</span>
                                                            <span *ngIf="sel.created_by != null"> {{ sel.created_by}}</span>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <strong>File</strong>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <span *ngIf="sel.file == null">No file recorded!</span>
                                                            <span *ngIf="sel.file != null"> <a href="{{fileStoragePath}}/ncr/{{sel.file}}" target="_new">{{sel.file}}</a></span>
                                                        </div>

                                                        <div class="col-md-3 align-items-center d-flex my-1">
                                                            <strong>Breach Details</strong>
                                                        </div>

                                                        <div class="col-md-9 align-items-center d-flex my-1" style="text-indent: 20px;">
                                                            {{sel.problem_details}}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <p *ngIf="!selected.length" style="text-align: center;">No Selections</p>
                                       
                                    </div>
                                </div>
                                
                                <div widget class="card border-0 box-shadow selected-column">
                                    <div class="card-header transparent border-0 text-muted">
                                        <h5 class="mb-0" style="text-align: center;">Corrective Action Report Details</h5>     
                                     </div><br>

                                    <div class="card-body pt-0 widget-body" *ngFor='let sel of selected'>
                                        <div *ngFor="let car of car_rows">
                                                <div class="col-md-12 details" *ngIf="sel.id == car.ncr_id">
                                                        <div class="row" *ngIf="car.status_id != 4 && car.status_id != 5">

                                                            <div class="col-md-3 align-items-center d-flex my-1" *ngIf="car.ca_name != '' && car.ca_name != null ">
                                                                <strong>Corrective Action</strong>
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1" *ngIf="car.ca_name != '' && car.ca_name != null ">
                                                                <span> {{car.ca_name}}</span>
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <strong>Person Involved</strong> 
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <span>{{(car.person_involved_name != null && car.person_involved_name !=''? car.person_involved_name : 'No Data Recorded')}}</span>
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <strong>QAR Distribution List </strong>
                                                            </div>

                                                            
                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <span>{{(dist_disp_length > 0 ? dist_disp : 'No Data Recorded')}}</span> 
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <strong>Status: </strong> 
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <span class="badge badge-pill" [ngClass]="{
                                                                    'badge-secondary': car?.status_id  == 1,
                                                                    'badge-primary': car?.status_id == 2,
                                                                    'badge-success': car?.status_id == 3,
                                                                    'badge-warning': car?.status_id  == 4,
                                                                    'badge-danger':  car?.status_id == 5
                            
                                                                    }">{{car?.status_name}}</span>
                                                            </div>

                                                            <div class="col-md-12 my-3">
                                                                <p class="mb-0" style="text-align: left; font-style: italic;">Corrective Action: Short Term Details</p>
                                                            </div>

                                                            <div class="col-md-3  my-1">
                                                                <strong> Corrective Action </strong> 
                                                            </div>

                                                            <div class="col-md-9 align-items-center d-flex my-1">
                                                                <span *ngIf="!car.ca_short_term_fix">No Data Recorded</span>
                                                                <span *ngIf="car.ca_short_term_fix" style="text-indent: 20px;">{{ car.ca_short_term_fix }}</span>
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <strong>Name of Person Closing Out </strong> 
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <span>{{(car.ca_short_close_out_person_name != null && car.ca_short_close_out_person_name != '') ? car.ca_short_close_out_person_name : 'No Data Recorded'}}</span>
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <strong>Closing Out Date</strong> 
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <span>{{(car.ca_short_close_out_date != null && car.ca_short_close_out_date != '') ? (car.ca_short_close_out_date | date: 'dd-MMM-yyyy') : 'No Data Recorded'}}</span>
                                                            </div>

                                                            <div class="col-md-12 my-3">
                                                                <p class="mb-0" style="text-align: left; font-style: italic;">Corrective Action: Long Term Details</p>
                                                            </div>

                                                            <div class="col-md-3 my-1">
                                                                <strong>Corrective Action </strong> 
                                                            </div>

                                                            <div class="col-md-9 align-items-center d-flex my-1">
                                                                <span *ngIf="!car.ca_long_term_fix">No Data Recorded</span>
                                                                <span *ngIf="car.ca_short_term_fix" style="text-indent: 20px;">{{ car.ca_long_term_fix }}</span>
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <strong>Name of Person Closing Out </strong> 
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <span>{{(car.ca_long_close_out_person_name != null && car.ca_long_close_out_person_name != '') ? car.ca_long_close_out_person_name : 'No Data Recorded'}}</span>
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <strong>Closing Out Date</strong> 
                                                            </div>

                                                            <div class="col-md-3 align-items-center d-flex my-1">
                                                                <span>{{(car.ca_long_close_out_date != null && car.ca_long_close_out_date != '') ? (car.ca_long_close_out_date | date: 'dd-MMM-yyyy') : 'No Data Recorded'}}</span>
                                                            </div>

                                                        </div>
                                                 </div>
                                        </div>         
                                    </div>
                                </div>
                                
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sm btn-secondary" (click)="close()" ngbAutofocus>Close</button>
                                </div>

                            </ng-template><!-- END OF NCR DETAILS-->
                        </div>
            </div>  
            <!------------ END TAB A ------------>
                    

            <!--------------- TAB B -------------->
            <div class="tab-pane" id="car">
                <!-- Feature Menu Icons-->
                <div class="row">
                    <div class="col-md-12">
                            
                        <!-- <button type="button" class="btn btn-secondary btn-sm mb-1 mr-1" aria-expanded="false" placement="bottom" ngbTooltip="Add New CAR" (click)="openCARModal(null)">
                                <span class="sr-only">Add</span>
                                <i class="fa fa-lg fa-plus"></i>
                                <span *ngIf="s_theme.menu_type == 'default'">&nbsp;Add</span>
                            </button> -->
                
                        <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print2()" placement="bottom" [disabled]="carCount < 1" ngbTooltip="Print List">
                            <i class="fa fa-lg fa-print"></i>
                            <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Print</span>
                        </button>
                            
                        <div class="btn-group mr-1">
                            <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="carCount < 1">
                                <i class="fa fa-lg fa-download"></i><span *ngIf="s_theme.menu_type == 'default'">&nbsp; Export</span>
                            </button>

                            <div class="dropdown-menu fs-12">
                                <a (click)="CAR_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                                <a (click)="CAR_exportToEXCEL()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                                <a (click)="CAR_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                            </div>
                        </div>
                            
                        <button type="button" [ngClass]="(showFilters2)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1" (click)="toggleFilters2()"  placement="bottom" ngbTooltip="Filter List">
                            <i class="fa fa-lg fa-filter"></i>
                            <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Filter</span>
                        </button>
                                            
                        <div class="btn-group mb-1">
                            <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="sr-only">Toggle Dropdown</span>
                                <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="s_theme.menu_type == 'default'">&nbsp; Columns</span>
                            </button>

                            <div class="dropdown-menu fs-12" style="width: 150px;">
                                <div class="col-md-12 mb-3 fs-12">
                                    <input type="checkbox" [(ngModel)]="showCarBreachCategory"> Breach Category<br />
                                    <input type="checkbox" [(ngModel)]="showCarCode"> Breach Code<br />
                                    <input type="checkbox" [(ngModel)]="showCarClassification"> Breach Classification<br />
                                    <input type="checkbox" [(ngModel)]="showCarProblemDetails"> Breach Details<br />
                                    <input type="checkbox" [(ngModel)]="showCorrectiveCAR"> Corrective Action<br />
                                    <input type="checkbox" [(ngModel)]="showRaisingPerson"> Raising Person<br />
                                    <input type="checkbox" [(ngModel)]="showRaisingDate"> Raising Date<br />
                                    <input type="checkbox" [(ngModel)]="showCarDriver"> Driver<br />
                                    <input type="checkbox" [(ngModel)]="showPersonInvolved"> Person Involved<br />
                                    <input type="checkbox" [(ngModel)]="showDistributionList"> Distribution List<br />
                                    <input type="checkbox" [(ngModel)]="showClosingOutDate"> Closing Out Date<br />
                                    <input type="checkbox" [(ngModel)]="showShortTermFix"> Short Term Fix<br />
                                    <input type="checkbox" [(ngModel)]="showShortCloseOutPerson"> Short Term Close Out Person<br />
                                    <input type="checkbox" [(ngModel)]="showShortCloseOutDate"> Short Term Close Out Date<br />
                                    <input type="checkbox" [(ngModel)]="showLongTermFix"> Long Term Fix<br />
                                    <input type="checkbox" [(ngModel)]="showLongTermCloseOutPerson"> Long Term Close Out Person<br />
                                    <input type="checkbox" [(ngModel)]="showLongTermCloseOutDate"> Long Term Close Out Date<br />
                                    <input type="checkbox" [(ngModel)]="showPersonInvolvedDate"> Person Involved Date Signed<br />
                                    <input type="checkbox" [(ngModel)]="showApprovedBy"> Approved By<br />
                                    <input type="checkbox" [(ngModel)]="showManagerSignedDate"> Approved Date<br />
                                </div>
                            </div>
                        </div>
                
                        <!-- <button type="button" [ngClass]="(showSidebar2)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 ml-1" (click)="toggleSideBar2()" placement="bottom" ngbTooltip="Toggle Sidebar">
                            <i class="fa fa-lg fa-toggle-right"></i>
                            <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Sidebar</span>
                        </button>         -->

                    </div>
                </div> 

                <!-- <div class="col-md-4">
                    <label>Short Term Fix:</label> 
                    <input type="text" class="form-control form-control-sm" (keyup)="updateCARFilter()" [(ngModel)]="filterShortFix">
                </div><br>

                <div class="col-md-4">
                    <label>Long Term Fix:</label> 
                    <input type="text" class="form-control form-control-sm" (keyup)="updateCARFilter()" [(ngModel)]="filterLongFix">
                </div>
            </div>       
       
        
                <div class="row" *ngIf="!isFilterEmpty">
                    <div class="col-md-12">
                        <button  type="button" class="btn btn-sm btn-success btn-sm mb-1" (click)="resetCARFilters()">
                            <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-filter"></i></span>
                            <span> Reset Filters</span>
                        </button> &nbsp;
                    </div> 
                </div>       -->

                <div class="row">
                <!-- START OF CAR TABLE  -->
                <div  class="col-md-12" align="left">
                <span  class="card-body">
                    <a (click)="onClickCARStatus('Cancelled');">
                    <span class="badge badge-pill badge-danger pull-right">
                    <span [hidden]="filterStatus != 'Cancelled'">
                    <i class="fa fa-check"></i>&nbsp;</span>Cancelled</span></a>
            
                    <a (click)="onClickCARStatus('Terminated');">
                    <span class="badge badge-pill badge-warning pull-right">
                    <span [hidden]="filterStatus != 'Terminated'">
                    <i class="fa fa-check"></i>&nbsp;</span>Terminated</span></a>
        
                    <a (click)="onClickCARStatus('Resolved');">
                    <span class="badge badge-pill badge-completed pull-right">
                    <span [hidden]="filterStatus != 'Resolved'">
                    <i class="fa fa-check"></i>&nbsp;</span>Resolved</span></a>
        
                    <a (click)="onClickCARStatus('Processing');">
                    <span class="badge badge-pill badge-processing pull-right">
                    <span [hidden]="filterStatus != 'Processing'">
                    <i class="fa fa-check"></i>&nbsp;</span>Processing</span></a>
        
                    <a (click)="onClickCARStatus('Pending');">
                    <span class="badge badge-pill badge-pending pull-right">
                    <span [hidden]="filterStatus != 'Pending'">
                    <i class="fa fa-check"></i>&nbsp;</span>Pending</span></a>                 
                </span>

                <ngx-loading [show]="loadingIndicator2"></ngx-loading>
                <ngx-datatable *ngIf = "car_rows && !loadingIndicator2"
                    [loadingIndicator]="loadingIndicator2"
                    class="material"
                    [rows]="car_rows"
                    [columnMode]="'force'"
                    [footerHeight]="40"
                    [columns]="car_columns"
                    [rowHeight]="'auto'"
                    [limit]="10"
                    [selected]="selected4"
                    [selectionType]="'single'"
                    (activate)="onActivate2($event)"
                    (select)='onSelect2($event)'
                    [headerHeight]="showFilters2?50:30">
                
                    <ngx-datatable-column prop="id" name="Operations" headerClass="header"  [cellClass]="getCellClass">
                        <ng-template let-value="value" let-row="row"  ngx-datatable-cell-template>
                            <div align="left" style="padding-right:20px">
                                <a class="hover difot" title="Details" (click)="openCARDetails()"><i class="fa fa-lg fa-book"></i></a>&nbsp;
                                <a class="hover difot" title="Edit Car" *ngIf="row.status_id != 4 && row.status_id != 5" (click)="openCARModal(row,true)"><i class="fa fa-lg fa-edit mr-1"></i></a>
                                <a class="hover difot" *ngIf="row.status_id != 1 && row.status_id != 2" placement="top" (click)="openPromptModalTask(modalTaskForm, null, row.id)" title="Create New Task"><i class="fa fa-lg fa-plus-square-o mr-1"></i></a>
                                <a  class="cursorhover" *ngIf="row.status_id != 3 && row.status_id != 5" placement="top" title="Cancel CAR" (click)="openModalCancel(row)"><i class="fa fa-lg fa-ban"></i></a>
                                <a *ngIf="row.carTaskCount > 0 && row.status_id != 3 && row.status_id != 5" title="Mark as Resolved" (click)="openMarkCompleteModal(modalMarkCompleted)"><i class="fa fa-lg fa-check-square-o ml-1"></i></a>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Breach Details" prop="problem_details"  headerClass="header" [width]="150" *ngIf="showCarProblemDetails" [cellClass]="getCellClass" ></ngx-datatable-column>
                                            
                    <ngx-datatable-column name="Breach Category" prop="category_name"  headerClass="header" [width]="120" *ngIf="showCarBreachCategory" [cellClass]="getCellClass"></ngx-datatable-column>

                    <ngx-datatable-column name="Breach Code" prop="codename"  headerClass="header" [width]="120" *ngIf="showCarCode" [cellClass]="getCellClass"></ngx-datatable-column>

                    <ngx-datatable-column name="Classification" prop="classification_name"  headerClass="header" [width]="120" *ngIf="showCarClassification" [cellClass]="getCellClass"></ngx-datatable-column>
                
                    <ngx-datatable-column name="Corrective Action" prop="ca_name"  *ngIf="showCorrectiveCAR" headerClass="header" [width]="150" [cellClass]="getCellClass">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters2">
                            <input type="text" [(ngModel)]="filterCorrectiveAction" style="height:17px" 
                            class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                            (keyup)="updateCARFilter()" />
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                
                    <ngx-datatable-column name="Raising Person" prop="raising_person"  *ngIf="showRaisingPerson"  headerClass="header" [width]="150"  [cellClass]="getCellClass">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters2">
                            <input type="text" [(ngModel)]="filterRaisingPerson" style="height:17px" 
                            class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                            (keyup)="updateCARFilter()" />
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                
                    <ngx-datatable-column prop="raising_date" name="Raising Date" headerClass="header" [cellClass]="getCellClass" *ngIf="showRaisingDate">
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <div align="left"  style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; " >  
                                <span title="{{row.raising_date}}">{{ (row.raising_date!== null && row.raising_date != '0000-00-00' ) ? (row.raising_date | date: 'dd MMM yyyy') : ""  }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Driver" prop="driver_name"  *ngIf="showCarDriver" headerClass="header" [width]="150"  [cellClass]="getCellClass">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters2">
                            <input type="text" [(ngModel)]="filterCarDriver" style="height:17px" 
                            class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                            (keyup)="updateCARFilter()" />
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                
                    <ngx-datatable-column name="Person Involved" prop="person_involved_name"  *ngIf="showPersonInvolved" headerClass="header" [width]="150"  [cellClass]="getCellClass">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters2">
                            <input type="text" [(ngModel)]="filterPersonInvolved" style="height:17px" 
                            class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                            (keyup)="updateCARFilter()" />
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                
                    <ngx-datatable-column name="Distribution List" prop="ncr_distribution_list"  *ngIf="showDistributionList" headerClass="header" [width]="150" [cellClass]="getCellClass" ></ngx-datatable-column>

                    <ngx-datatable-column name="Closing Out Date" prop="close_out_date"  *ngIf="showClosingOutDate" headerClass="header" [width]="120" [cellClass]="getCellClass">
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                            <span title="{{row.close_out_date}}">{{ (row.close_out_date!== null && row.close_out_date != '0000-00-00' ) ? (row.close_out_date| date: 'dd MMM yyyy') : "No Date"  }}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Short Term Fix" prop="ca_short_term_fix"  *ngIf="showShortTermFix" headerClass="header" [width]="120" [cellClass]="getCellClass" ></ngx-datatable-column>

                    <ngx-datatable-column name="Short Term Close Out Person" prop="ca_short_close_out_person_name"  *ngIf="showShortCloseOutPerson" headerClass="header" [width]="120" [cellClass]="getCellClass" ></ngx-datatable-column>

                    <ngx-datatable-column prop="ca_short_close_out_date" name="Short Term Close Out Date" headerClass="header" [cellClass]="getCellClass" *ngIf="showShortCloseOutDate">
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <div align="left"  style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; " >  
                                <span title="{{row.ca_short_close_out_date}}">{{ (row.ca_short_close_out_date!== null && row.ca_short_close_out_date != '0000-00-00' ) ? (row.ca_short_close_out_date| date: 'dd MMM yyyy') : "No Date"  }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Long Term Fix" prop="ca_long_term_fix"  *ngIf="showLongTermFix" headerClass="header" [width]="120" [cellClass]="getCellClass" ></ngx-datatable-column>

                    <ngx-datatable-column name="Long Term Close Out Person" prop="ca_long_close_out_person_name"  *ngIf="showLongTermCloseOutPerson" headerClass="header" [width]="120" [cellClass]="getCellClass" ></ngx-datatable-column>

                    <ngx-datatable-column name="Long Term Close Out Date" prop="ca_long_close_out_date"  *ngIf="showLongTermCloseOutDate" headerClass="header" [width]="120" [cellClass]="getCellClass">
                        <ng-template let-value="value" let-row="row"  ngx-datatable-cell-template>
                            <span title="{{row.ca_long_close_out_date}}">{{ (row.ca_long_close_out_date!== null && row.ca_long_close_out_date != '0000-00-00' ) ? (row.ca_long_close_out_date| date: 'dd MMM yyyy') : "No Date"  }}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Person Involved Date Signed" prop="person_involved_date_signed"  *ngIf="showPersonInvolvedDate" headerClass="header" [width]="120" [cellClass]="getCellClass">
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                            <span title="{{row.person_involved_date_signed}}">{{ (row.person_involved_date_signed!== null && row.person_involved_date_signed != '0000-00-00' ) ? (row.person_involved_date_signed| date: 'dd MMM yyyy') : "No Date"  }}</span>

                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Approved By" prop="approved_name"  *ngIf="showApprovedBy" headerClass="header" [width]="120" [cellClass]="getCellClass" ></ngx-datatable-column>

                    <ngx-datatable-column name="Approved Date" prop="approved_date"  *ngIf="showManagerSignedDate" headerClass="header" [width]="120" [cellClass]="getCellClass">
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                            <span title="{{row.approved_date}}">{{ (row.approved_date!== null && row.approved_date != '0000-00-00' ) ? (row.approved_date| date: 'dd MMM yyyy') : "No Date"  }}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="File" prop="file"  *ngIf="showFileCAR" headerClass="header" [width]="120" [cellClass]="getCellClass" >
                        <ng-template let-value="value" ngx-datatable-cell-template>
                            <a class="incident_hover" href="{{fileStoragePath}}/ca_report/{{value}}" target="_new">{{value}}</a>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
            <!-- END OF CAR TABLE -->

     <!-- START OF CAR DETAILS -->
    <ng-template #modalCARDetails let-close="close">
        <div class="card-header transparent border-0 text-muted">
            <h5 class="mb-0" style="text-align: center;">Corrective Action Report Details</h5>     
        </div><br>

        <div class="card-body pt-0 widget-body">
                <div *ngFor='let sel of selected4, let i = index'>
                    <div class="col-md-12 details">
                        <div class="row">

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Breach Category</strong>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                {{ sel.category_name }}
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Raising Person</strong>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                {{sel.raising_person}}
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Breach Code</strong>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                {{sel.codename}}
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Raising Date</strong>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <span> {{sel.raising_date != null && sel.raising_date != '' ? (formatDate(sel.raising_date) | date: 'dd MMM yyyy') : "No Data Recorded"  }} </span>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Breach Classification</strong>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                {{ sel.classification_name}}
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Status</strong>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">

                                <span class="badge badge-pill" [ngClass]="{
                                        'badge-secondary': sel?.status_id  == 1,
                                        'badge-primary': sel?.status_id == 2,
                                        'badge-success': sel?.status_id == 3,
                                        'badge-warning': sel?.status_id  == 4,
                                        'badge-danger':  sel?.status_id == 5

                                        }">{{sel?.status_name}}</span>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Breach Details</strong>
                            </div>

                            <div class="col-md-9 align-items-center d-flex my-1">
                                <span *ngIf="!sel.problem_details">No Data Recorded</span>
                                <span *ngIf="sel.problem_details" style="text-indent: 20px;">{{sel.problem_details}}</span>
                            </div>

                            <div class="col-md-12 my-3">
                                <p class="mb-0" style="text-align: left; font-style: italic;">Corrective Action: Short Term Details</p>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Short Term Fix: </strong>
                            </div>

                            <div class="col-md-9 align-items-center d-flex my-1">
                                <span *ngIf="!sel.ca_short_term_fix">No Data Recorded</span>
                                <span *ngIf="sel.ca_short_term_fix" style="text-indent: 20px;">{{sel.ca_short_term_fix}}</span>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Name of Person Closing Out</strong>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <span>{{ (sel.ca_short_close_out_person_name != null && sel.ca_short_close_out_person_name != '') ? sel.ca_short_close_out_person_name : "No Data Recorded"}}</span>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Close Out Date</strong>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <span> {{sel.ca_short_close_out_date != null && sel.ca_short_close_out_date != '' ? (formatDate(sel.ca_short_close_out_date) | date: 'dd MMM yyyy') : "No Data Recorded"  }} </span>
                            </div>

                            <div class="col-md-12 my-3">
                                <p class="mb-0" style="text-align: left; font-style: italic;">Corrective Action: Long Term Details</p>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Long Term Fix: </strong>
                            </div>

                            <div class="col-md-9 align-items-center d-flex my-1">
                                <span *ngIf="!sel.ca_long_term_fix">No Data Recorded</span>
                                <span *ngIf="sel.ca_long_term_fix" style="text-indent: 20px;">{{sel.ca_long_term_fix}}</span>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Name of Person Closing Out</strong>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <span>{{ (sel.ca_long_close_out_person_name != null && sel.ca_long_close_out_person_name != '') ? sel.ca_long_close_out_person_name : "No Data Recorded"}}</span>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <strong>Close Out Date</strong>
                            </div>

                            <div class="col-md-3 align-items-center d-flex my-1">
                                <span> {{sel.ca_long_close_out_date != null && sel.ca_long_close_out_date != '' ? (formatDate(sel.ca_long_close_out_date) | date: 'dd MMM yyyy') : "No Date"  }} </span>
                            </div>

                        </div>
                    </div>
                </div>
        </div>
    <br>

    <div widget class="card border-0 box-shadow selected-column">
        <div class="card-header transparent border-0 text-muted">
            <h5 class="mb-0" style="text-align: center;">Corrective Action Report Tasks</h5>
        </div>

        <div class="card-body pt-0 widget-body">
            <div *ngFor='let sel4 of selected4'>
                <div *ngIf ="sel4.carTaskCount > 0">
                    <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="openMarkCompleteModal(modalMarkCompleted)">
                        <span class="badge badge-pill badge-white text-primary ml-1">
                            <i class="fa fa-check-square-o"></i>
                        </span>Mark as Resolved
                    </button>
                    <br />
                    
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th></th>
                                <th style="text-align: center;"><strong class="text-muted" >Title</strong></th>
                                <th style="text-align: center;"><strong class="text-muted" >Assigned To</strong></th>
                                <th style="text-align: center;"><strong class="text-muted" >% Done</strong></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let task of tasksByCarId | paginate: { itemsPerPage: 5, currentPage: ip }">
                                <td>
                                    <small style="font-size: 12px;">
                                        <i class="fa fa-pencil" title="Edit Task"  (click)="openPromptModalTask(modalTaskForm, task, sel4.id)" ></i>
                                        <i class="fa fa-trash" title="Delete Task" (click)="openPromptModalTask(modalDeleteTask, task, prefixCAR)"></i>
                                    </small>
                                </td>

                                <td class="text-muted" style="text-align: center;">{{task.title}}</td>
                                <td class="text-muted" style="text-align: center;">{{task.assignedTo_name}}</td>
                                <td class="text-muted" style="text-align: center;">{{task.percent_done}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="row">
                        <div class="col-12">
                            <div class="bg-white text-center">
                                <small><pagination-controls autoHide="true" (pageChange)="ip = $event" maxSize="10"></pagination-controls></small>
                            </div>        
                        </div>
                    </div> 
                </div>
                <p *ngIf="sel4.carTaskCount == 0">*No Recorded Task for this Report.</p>   
            </div>  
        </div>
    </div>    

    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()" ngbAutofocus>Close</button>
    </div>

        </ng-template><!-- END OF CAR DETAILS-->
    </div>
</div>
<!------------ END TAB B ------------->
</div>
</div>
</div>


    <!-- START PRINT for NCR-->
    <div id="print-section1" style="display:none">
        <table style="width:100%">
                <tr>
                    <th align="left">Control Number</th>
                    <th align="left" *ngIf="showBreachCategory">Breach Category</th>
                    <th align="left" *ngIf="showCode">Code</th>
                    <th align="left" *ngIf="showClassification">Classification</th>
                    <th align="left" *ngIf="showStatus">Status</th>
                    <th align="left" *ngIf="showDriver">Driver</th> 
                    <th align="left" *ngIf="showProblemDetails">Breach Details</th>    
                </tr>
                <tr *ngFor="let row of ncr_rows">
                    <td>{{ row.control_no}}</td>
                    <td *ngIf="showBreachCategory">{{ row.category_name }}</td>
                    <td *ngIf="showCode">{{row.codename}}</td>
                    <td *ngIf="showClassification">{{row.classification_name}}  </td>
                    <td *ngIf="showStatus">{{row.status_name}}</td>
                    <td *ngIf="showDriver">{{row.driver_name}}</td>
                    <td *ngIf="showProblemDetails">{{row.problem_details}}</td>
                </tr>
        </table>
    </div>
    <!-- END PRINT -->

    <!-- START PRINT for CAR-->
    <div id="print-section2" style="display:none">
        <table style="width:100%">
            <tr>
                <th align="left" *ngIf="showCarBreachCategory">Breach Category</th>
                <th align="left" *ngIf="showCarCode">Code</th>
                <th align="left" *ngIf="showCarClassification">Classification</th>
                <th align="left" *ngIf="showStatus">Status</th>
                <th align="left" *ngIf="showCarProblemDetails">Breach Details</th>    
                <th align="left" *ngIf="showCorrectiveCAR">Corrective Action</th>    
                <th align="left" *ngIf="showRaisingPerson">Raising Person</th> 
                <th align="left" *ngIf="showRaisingDate">Raising Date</th>
                <th align="left" *ngIf="showCarDriver">Driver</th>
                <th align="left" *ngIf="showPersonInvolved">Person Involved</th>
                <th align="left" *ngIf="showDistributionList">Distribution List</th>
                <th align="left" *ngIf="showClosingOutDate"> Closing Out Date</th>
                <th align="left" *ngIf="showShortTermFix">Short Term Fix</th>
                <th align="left" *ngIf="showShortCloseOutPerson">Short Term Close Out Person</th>
                <th align="left" *ngIf="showShortCloseOutDate">Short Term Close Out Date</th>
                <th align="left" *ngIf="showLongTermFix">Long Term Fix</th>
                <th align="left" *ngIf="showLongTermCloseOutPerson">Long Term Close Out Person</th>
                <th align="left" *ngIf="showLongTermCloseOutDate">Long Term Close Out Date</th>
                <th align="left" *ngIf="showPersonInvolvedDate"> Person Involved Date Signed</th>
                <th align="left" *ngIf="showApprovedBy">Approved By</th>
                <th align="left" *ngIf="showManagerSignedDate">Approved Date</th>
            </tr>

            <tr *ngFor="let row of car_rows">
                <td *ngIf="showCarBreachCategory">{{ row.category_name }}</td>
                <td *ngIf="showCarCode">{{row.codename}}</td>
                <td *ngIf="showCarClassification">{{row.classification_name}}  </td>
                <td *ngIf="showStatus">{{row.status_name}}</td>
                <td *ngIf="showCarProblemDetails">{{row.problem_details}}</td>
                <td *ngIf="showCorrectiveCAR">{{row.ca_name}}</td>
                <td *ngIf="showRaisingPerson">{{row.raising_person}}</td>
                <td *ngIf="showRaisingDate">{{row.raising_date}}</td>
                <td *ngIf="showCarDriver">{{row.driver_name}}</td>
                <td *ngIf="showPersonInvolved">{{row.person_involved_name}}</td>
                <td *ngIf="showDistributionList">{{row.ncr_distribution_list}}</td>
                <td *ngIf="showClosingOutDate">{{row.close_out_date}}</td>
                <td *ngIf="showShortTermFix">{{row.ca_short_term_fix}}</td>
                <td *ngIf="showShortCloseOutPerson">{{row.ca_short_close_out_person_name}}</td>
                <td *ngIf="showShortCloseOutDate">{{row.ca_short_close_out_date}}</td>
                <td *ngIf="showLongTermFix">{{row.ca_long_term_fix}}</td>
                <td *ngIf="showLongTermCloseOutPerson">{{row.ca_long_close_out_person_name}}</td>
                <td *ngIf="showLongTermCloseOutDate">{{row.ca_long_close_out_date}}</td>
                <td *ngIf="showPersonInvolvedDate">{{row.person_involved_date_signed}}</td>
                <td *ngIf="showApprovedBy">{{row.approved_name }}</td>
                <td *ngIf="showManagerSignedDate">{{row.approved_date }}</td>
            </tr>
        </table>
    </div>
<!-- END PRINT -->


    <!-- START OF ADD/EDIT NCR FORM -->
    <ng-template #modalNCR let-close="close">
        <div class="modal-header">
                <h5 class="modal-title" *ngIf="isEditMode==false">Add Quality Assurance Report</h5>
                <h5 class="modal-title" *ngIf="isEditMode==true">Edit Quality Assurance Report</h5>
                <button type="button" class="close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
        </div>
        <form [formGroup]="NCRForm" (ngSubmit)="onSubmitNCR(NCRForm.value)">
            <div class="modal-body">
                <div class="row pt-0">
                    <div class="form-group col-md-4" >
                        <h6>Breach Category<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="category_id">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let br of breach_categories" value="{{br.id}}">{{br.breach_cat_name}}</option>
                        </select>
                    </div>
   
                    <div class="form-group col-md-4" >
                        <h6>Breach Code<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="code_id">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let code of breach_codes" value="{{code.id}}">{{code.ncr_codename}}</option>
                        </select>
                    </div>

                    <div class="form-group col-md-4" >
                        <h6>Breach Classification<span class="text-danger">*</span> :</h6>                    
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="classification_id">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let class of breach_classification" value="{{class.id}}">{{class.classification_name}}</option>
                        </select>
                    </div>

                    <!-- <div class="form-group col-md-4" >
                        <h6>Status<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="status_name">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let st of breach_status" value="{{st.status_name}}">{{st.status_name}}</option>
                        </select>
                    </div> -->

                    <!-- <div class="form-group col-md-4">
                        <h6>Driver<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="driver_id">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.first_name}}  {{dr.last_name}}</option>
                        </select>   
                    </div> -->

                    <div class="form-group col-md-4">
                        <h6>Driver<span class="text-danger">*</span> :</h6>
                        <ss-multiselect-dropdown [options]="pushDriverOptions" [(ngModel)]="pushDriverModel" [ngModelOptions]="{standalone: true}" [texts]="pushDriver" [settings]="pushDriverSettings"></ss-multiselect-dropdown>                        
                        &nbsp;<small *ngIf="!checkDriverModel()" class="text-danger" >Required</small>
                    </div>

                    <div class="form-group col-md-4">
                        <h6>Fleet<span class="text-danger" *ngIf="NCRForm.value.classification_id == 4">*</span> :</h6>
                        <!-- <select class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id">
                            <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                            <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.rego}}</option>
                        </select> -->
                        <ss-multiselect-dropdown [options]="pushFleetOptions" [(ngModel)]="pushFleetModel" [ngModelOptions]="{standalone: true}" [texts]="pushFleet" [settings]="pushFleetSettings"></ss-multiselect-dropdown>                        
                        &nbsp;<small *ngIf="!checkPushModel()  && NCRForm.value.classification_id == 4" class="text-danger" >Required</small>
                    </div>

                    <div class="form-group col-md-4">
                        <h6>Customer</h6>
                        <div class="input-group d-flex align-items-center">
                        <select class="form-control form-control-sm" placeholder="Select" formControlName="customer_id">
                            <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                            <option *ngFor="let cust of customer" value="{{cust.id}}" [ngClass]="{'font-italic': cust.deleted_date != null}">{{cust.company_name}}</option>
                        </select>
                        <i (click)="resetFormControl('ncr')" ngbTooltip="Clear Customer" class="fa fa-eraser ml-2" aria-hidden="true"></i>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group">
                            <h6 for="input-1">Breach Details<span class="text-danger">*</span> :</h6>
                            <textarea class="form-control form-control-sm" formControlName="problem_details" rows="4" cols="50"></textarea>
                        </div>
                    </div>


                    <div class="form-group col-md-4" >
                        <h6>Manifest Control Number<span class="text-danger" *ngIf="NCRForm.value.classification_id == 4 || NCRForm.value.classification_id == 6">*</span> :</h6>
                        <input formControlName="run_control_no" class="form-control form-control-sm" type="text">
                    </div>

                    <div class="form-group col-md-4">
                        <div class="form-group" *ngIf ="(fileExists==true)">
                            <h6>File:</h6>
                            <label>{{NCRForm.value?.supporting_docs}}</label> <button class="btn btn-sm btn-primary ml-1" type="button" (click)="removeFile(prefixNCR)">Remove File</button>
                        </div>
                        <div class="form-group" *ngIf ="(fileExists==false)">
                            <h6>File :</h6>
                            <app-file-uploader (passFile)="getFile($event, prefixNCR)"></app-file-uploader>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
                <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
                <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
                <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!NCRForm.valid || spinner == true|| !isDriverSelected || !is_image || (NCRForm.value.classification_id == 4 && (!checkPushModel() || !NCRForm.value.run_control_no)) || (NCRForm.value.classification_id == 6 && !NCRForm.value.run_control_no)">Save</button>
                <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!NCRForm.valid || spinner == true|| !isDriverSelected || !is_image || (NCRForm.value.classification_id == 4 && (!checkPushModel() || !NCRForm.value.run_control_no)) || (NCRForm.value.classification_id == 6 && !NCRForm.value.run_control_no)">Save Changes</button>
    
                <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()" [disabled]="spinner == true"  ngbAutofocus >Cancel</button>
            </div>
        </form>
    </ng-template><!-- END OF MODAL ADD NCR FORM -->


    <!--START OF Delete NCR Modal -->
    <ng-template #modalDelete>
        <div class="modal-header">
            <h5 class="modal-title">Delete Quality Assurance Report</h5>
            <button type="button" class="close" (click)="closeModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row pt-0">
                <div class="col-md-12">
                Are you sure to delete this Quality Assurance Report?
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button type="button" class="btn btn-sm btn-danger" (click)="deleteNCR(objToDelete)" [disabled]="spinner == true">Delete</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
        </div>
    </ng-template> <!--END OF Delete NCR-->


    <!-- START OF ADD/EDIT CAR FORM -->
    <ng-template #modalCAR let-close="close">
        <div class="modal-header">
            <h5 class="modal-title" *ngIf="isEditMode==false">Add New CAR</h5>
            <h5 class="modal-title" *ngIf="isEditMode==true">Edit Corrective Action Report</h5>
            <button type="button" class="close" (click)="closeModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <form [formGroup]="CARForm" (ngSubmit)="onSubmitCAR(CARForm.value)">
            <div class="modal-body">
                <div class="row pt-0">
                    <div class="form-group col-md-4">
                        <h6>Breach Category<span class="text-danger">*</span> :</h6>
                        <select class="form-control form-control-sm" placeholder="Select" formControlName="breach_category_id">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let br of car_categories" value="{{br.id}}">{{br.breach_name}}</option>
                        </select>
                    </div>

                    <!-- <div class="form-group col-md-4">
                        <h6>Driver<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="driver_id">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.first_name}}  {{dr.last_name}}</option>
                        </select>   
                    </div> -->

                    <div class="form-group col-md-4">
                        <h6>Driver<span class="text-danger">*</span> :</h6>
                        <ss-multiselect-dropdown [options]="pushDriverOptions" [(ngModel)]="pushDriverModel" [ngModelOptions]="{standalone: true}" [texts]="pushDriver" [settings]="pushDriverSettings"></ss-multiselect-dropdown>                        
                        &nbsp;<small *ngIf="!checkDriverModel()" class="text-danger" >Required</small>
                    </div>

                    <div class="form-group col-md-4">
                        <h6>Raising Date<span class="text-danger">*</span> :</h6>
                        <input formControlName="raising_date" class="form-control form-control-sm" type="date" max="{{dateNow|date:'yyyy-MM-dd'}}">
                    </div>


                    <div class="form-group col-md-4">
                        <h6>Breach Code<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="code_id">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let code of car_codes" value="{{code.id}}">{{code.ca_codename}}</option>
                        </select>
                    </div>

                    <div class="form-group col-md-4">
                        <h6>Status<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="status_id">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let st of car_status" value="{{st.id}}">{{st.stat_name}}</option>
                        </select>
                    </div>

                    <div class="form-group col-md-4">
                        <h6>Closed Date:</h6>
                        <input formControlName="close_out_date" class="form-control form-control-sm" type="date" max="{{dateNow|date:'yyyy-MM-dd'}}">
                    </div>

                    <div class="form-group col-md-4">
                        <h6>Breach Classification<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="classification_id">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let class of car_classification" value="{{class.id}}">{{class.classification_name}}</option>
                        </select>
                    </div>

                    <div class="form-group col-md-4">
                        <h6>Manifest Control Number<span class="text-danger" *ngIf="CARForm.value.classification_id == 4 || CARForm.value.classification_id == 4">*</span> :</h6>
                        <input formControlName="run_control_no" class="form-control form-control-sm" type="text">
                    </div>

                    <div class="form-group col-md-4">
                        <div class="form-group" *ngIf ="(fileExists==true)">
                            <h6>File:</h6>
                            <label>{{CARForm.value?.supporting_docs}}</label> <button class="btn btn-sm btn-primary ml-1" type="button" (click)="removeFile(prefixCAR)">Remove File</button>
                        </div>
                        <div class="form-group" *ngIf ="(fileExists==false)">
                            <h6>File :</h6>
                            <app-file-uploader (passFile)="getFile($event, prefixCAR)"></app-file-uploader>
                        </div>
                    </div>
                    

                    <div class="col-md-8">
                        <div class="form-group">
                            <h6 for="input-1">Breach Details<span class="text-danger">*</span> :</h6>
                            <textarea class="form-control form-control-sm" formControlName="problem_details" rows="4" cols="50"></textarea>
                        </div>
                    </div>


                    <div class="form-group col-md-4">
                        <h6>Fleet<span class="text-danger" *ngIf="CARForm.value.classification_id == 4 ">*</span> :</h6>
                        <ss-multiselect-dropdown [options]="pushFleetOptions" [(ngModel)]="pushFleetModel" [ngModelOptions]="{standalone: true}" [texts]="pushFleet" [settings]="pushFleetSettings"></ss-multiselect-dropdown>                        
                        &nbsp;<small *ngIf="!checkPushModel() && CARForm.value.classification_id == 4" class="text-danger" >Required</small>
                    </div>

                    <div class="form-group col-md-4">
                        <h6 for="input-1">QAR Distribution List<span class="text-danger">*</span> :</h6>
                        <div formArrayName="ca_distribution_list">
                          <div *ngFor="let item of caDistributionArray.controls; let i = index" [formGroupName]="i">
                            <input 
                              type="checkbox" 
                              formControlName="checked"
                              ng-true-value="1" 
                              ng-false-value="0"
                            > {{ item.get('name').value }}<br />
                          </div>
                        </div>
                      </div>

                    <div class="form-group col-md-4">
                        <h6>Customer</h6>
                        <div class="input-group d-flex align-items-center">
                            <select class="form-control form-control-sm" placeholder="Select" formControlName="customer_id">
                                <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                                <option *ngFor="let cust of customer" value="{{cust.id}}" [ngClass]="{'font-italic': cust.deleted_date != null}">{{cust.company_name}}</option>
                            </select>
                            <i (click)="resetFormControl('car')" ngbTooltip="Clear Customer" class="fa fa-eraser ml-2" aria-hidden="true"></i>
                        </div>
                    </div>

                    <div class="form-group col-md-4" >
                        <h6>Corrective Action<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="ca_id">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let action of car_corrective_action" value="{{action.id}}">{{action.corrective_action_name}}</option>
                        </select>
                    </div>

                    <div class="col-md-6">
                        <h6>Name of Person Closing Out Short Term NCR:</h6>
                        <div class="input-group input-group-sm">
                            <select  class="form-control form-control-sm" placeholder="Select" formControlName="ca_short_close_out_person">
                                <option disabled selected *ngIf="isEditMode==false">Select..</option>
                                <option *ngFor="let us of users" value="{{us.id}}">{{us.display_name}}</option>
                            </select>   
                        </div>
                    </div>  

                    <div class="form-group col-md-6" >
                        <h6>Short Term Fix - Close Out Date:</h6>
                        <input formControlName="ca_short_close_out_date" class="form-control form-control-sm" type="date" max="{{dateNow|date:'yyyy-MM-dd'}}">
                    </div>

                    <div class="col-md-12">
                        <div class="form-group">
                            <h6 for="input-1"> Short Term Fix - Corrective Action:</h6>
                            <textarea class="form-control form-control-sm" formControlName="ca_short_term_fix" rows="4" cols="50"></textarea>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h6>Name of Person Closing Out Long Term NCR:</h6>
                        <div class="input-group input-group-sm">
                            <select  class="form-control form-control-sm" placeholder="Select" formControlName="ca_long_close_out_person">
                                <option disabled selected *ngIf="isEditMode==false">Select..</option>
                                <option *ngFor="let us of users" value="{{us.id}}">{{us.display_name}}</option>
                            </select>   
                        </div>
                    </div>  

                    <div class="form-group col-md-6" >
                        <h6>Long Term Fix - Close Out Date:</h6>
                        <input formControlName="ca_long_close_out_date" class="form-control form-control-sm" type="date" max="{{dateNow|date:'yyyy-MM-dd'}}">
                    </div>

                    <div class="col-md-12">
                        <div class="form-group">
                            <h6 for="input-1"> Long Term Fix - Corrective Action:</h6>
                            <textarea class="form-control form-control-sm" formControlName="ca_long_term_fix" rows="4" cols="50"></textarea>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h6>Name of Person Responsible:</h6>
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control form-control-sm" formControlName="person_involved_name">
                        </div>
                    </div>  

                    <div class="col-md-6" >
                        <h6>Approved by:</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="approved_by">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let us of users" value="{{us.id}}">{{us.display_name}}</option>
                        </select>   
                    </div>

                    <div class="form-group col-md-6" >
                        <h6>Person Responsible Date Signed:</h6>
                        <input formControlName="person_involved_date_signed" class="form-control form-control-sm" type="date" max="{{dateNow|date:'yyyy-MM-dd'}}">
                    </div>

                    <div class="col-md-6" >
                        <h6>Approved Date :</h6>
                        <input formControlName="approved_date" class="form-control form-control-sm" type="date" max="{{dateNow|date:'yyyy-MM-dd'}}">
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
                <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
                <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!CARForm.valid || !isDriverSelected || spinner == true || !is_image || (CARForm.value.classification_id == 4 && (!checkPushModel() || !CARForm.value.run_control_no)) || (CARForm.value.classification_id == 6 && !CARForm.value.run_control_no)">Save</button>
                <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!CARForm.valid ||!isDriverSelected ||  spinner == true ||!is_image || (CARForm.value.classification_id == 4 && (!checkPushModel() || !CARForm.value.run_control_no)) || (CARForm.value.classification_id == 6 && !CARForm.value.run_control_no)">Save Changes</button>
                <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()" ngbAutofocus [disabled]="spinner == true">Cancel</button>
            </div>
        </form>
    </ng-template> <!-- END OF MODAL ADD/EDIT CAR FORM -->

    <!--START OF CANCEL CAR Modal-->
    <ng-template #modalCancel>
        <div class="modal-header">
            <h5 class="modal-title">Cancel Corrective Action Report</h5>
            <button type="button" class="close" (click)="closeModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row pt-0">
                <div class="col-md-12">
                Are you sure to cancel this corrective action report?
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-danger" (click)="cancelCar(objToDelete)" [disabled]="spinner == true" >Yes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
        </div>
    </ng-template><!--END OF CANCEL CAR-->


    <!-- START OF TASK MODAL FORM -->
    <ng-template #modalTaskForm let-close="close">
        <div class="modal-header">
            <h5 class="modal-title">{{action}} Task</h5>
            <button type="button" class="close" (click)="close()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <app-addupdatetask [task]="task ? task : null" [caller]="prefixCAR" [objectId]="carId"   (closeModal)="closeModalTask()"></app-addupdatetask>
    </ng-template><!-- END OF TASK MODAL FORM -->


    <!-- START OF DELETE TASK FORM -->
    <ng-template #modalDeleteTask let-close="close">
        <div class="modal-header">
            <h5 class="modal-title">Delete Task</h5>
            <button type="button" class="close" (click)="close()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row pt-0">
                <div class="col-md-12">
                Do you really want to delete <b><i>{{task_title}}</i></b>?
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button type="button" class="btn btn-sm btn-danger"  (click)="deleteTask(task.id)"  [disabled]="spinner == true">Delete</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
        </div>
    </ng-template><!-- END OF MODAL DELETE TASK FORM -->

    <!--- START OF MARK ALL TASK COMPLETED MODAL -->
    <ng-template #modalMarkCompleted let-close="close">
        <div class="modal-header">
            <h5 class="modal-title">Mark Tasks Resolved</h5>
            <button type="button" class="close" (click)="closeModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row pt-0">
                <div class="col-md-12">
                    <p>Are you sure you want to mark all task for this Corrective Action Report resolved?</p>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button type="button" class="btn btn-sm btn-success" (click)="markCompleted(selected4[0].id)" [disabled]="spinner == true">Yes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">No</button>
        </div>
    </ng-template><!-- END OF MARK ALL TASK COMPLETED MODAL -->
